import { t } from '@lingui/core/macro';

export default function boardNameValidator(boardName?: string, existNames?: string[]) {
  if (!boardName || boardName.length <= 0) {
    return t`Название табло не может быть пустым`;
  }
  if (existNames && existNames.includes(boardName)) {
    return t`Такое название уже существует, придумайте новое`;
  }
  return undefined;
}
